"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
exports.__esModule = true;
var getValue_1 = require("./getValue");
function getArrayValue(_a, config) {
    var _b;
    var $ = _a.$, element = _a.el;
    var values = [];
    if ((_b = config === null || config === void 0 ? void 0 : config.methods) === null || _b === void 0 ? void 0 : _b.includes('size')) {
        return $(element).length;
    }
    function eachFunction(index, el) {
        var selector = config.selector, type = config.type, rest = __rest(config, ["selector", "type"]);
        var value = getValue_1["default"]({ $: $, el: $(el) }, rest);
        values.push(value);
    }
    if (typeof (config === null || config === void 0 ? void 0 : config.elementFilter) === 'function') {
        $(element)
            .filter(function (index, el) { return config.elementFilter(index, el, $); })
            .each(eachFunction);
    }
    else {
        $(element).each(eachFunction);
    }
    return values;
}
exports["default"] = getArrayValue;
